import { LayoutService } from '../services/layout.service';
import {
    Directive,
    Input,
    Output,
    EventEmitter,
    HostListener,
    Renderer2,
    ElementRef,
    ApplicationRef,
    ViewChild,
    ViewContainerRef } from '@angular/core';
import { ContextMenuPanelComponent } from './context-menu-panel.component';
import { ContextMenu } from './context-menu';
import { Overlay, OverlayConfig, OverlayRef, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { OverlayOrigin } from '@angular/cdk/overlay';
import { Observable} from 'rxjs/Observable';
import'rxjs/add/observable/zip';
import { ContextMenuService } from './context-menu.service';
export class ContextMenuDirective {

       hdContextMenu = new EventEmitter();
       menuID: any; // id dari row yg diklik kanan
       menuItem: [ContextMenu]; // data menu yg akan ditampikan, data ini sesuai dengan interface framework contextmenu
       _overlayOrigin: CdkOverlayOrigin;
       contextMenuOrigin: CdkOverlayOrigin;
      panel: any;
      clickWatcher$: any;
      overlayRef: OverlayRef;
      active = false;
/**
 * @param {?} ref
 * @param {?} render
 * @param {?} ar
 * @param {?} vc
 * @param {?} overlay
 * @param {?} layoutService
 * @param {?} _service
 */
constructor(
private ref: ElementRef,
private render: Renderer2,
private ar: ApplicationRef,
private vc: ViewContainerRef,
public overlay: Overlay,
public layoutService: LayoutService,
private _service: ContextMenuService
      ) {
            render.setStyle(ref.nativeElement, 'cursor', 'context-menu'); // add context-menu cursor to element used this directive
      }
/**
 * @param {?} event
 * @return {?}
 */
onContextMenu(event: MouseEvent): void {
            event.preventDefault();
            event.stopPropagation();
            this._service.closeAllContextMenus();
            const /** @type {?} */ refs = this._service.getRef();
            if (refs) {
               refs.forEach((ref, index) => {
                  this.render.removeClass(ref.nativeElement, 'hd-contextmenu-active');
               });
            }
            this._service.destroyAllRef();

            this._service.setRef(this.ref);
            this.render.addClass(this.ref.nativeElement, 'hd-contextmenu-active'); // coloring row with class
            this.createPanel(event);
            this.addPanelItem();
            this.watchItemClick();
            this.outsideListener();
      }
/**
 * @param {?} event
 * @return {?}
 */
private createPanel(event): void {
            const /** @type {?} */ offsetX = event.offsetX;
            const /** @type {?} */ offsetY = event.offsetY;
            const /** @type {?} */ positionStrategy = this.overlay.position()
               .connectedTo(
                  {nativeElement: event.target},
                  { originX: 'start', originY: 'top' },
                  { overlayX: 'start', overlayY: 'top' })
               .withOffsetX(offsetX)
               .withOffsetY(offsetY);
            const /** @type {?} */ config = new OverlayConfig({
                positionStrategy: positionStrategy,
                scrollStrategy: this.overlay.scrollStrategies.reposition(),
                panelClass: 'contextmenu-overlay'
            });
            this.overlayRef = this.overlay.create(config);
            this._service.setContextMenuOverlay(this.overlayRef);
            const /** @type {?} */ contextMenu = new ComponentPortal(ContextMenuPanelComponent);
            this.panel = this.overlayRef.attach(contextMenu);
            this.active = true;
      }
/**
 * @return {?}
 */
private addPanelItem(): void {
            this.panel.instance.menuItem = this.menuItem;
      }
/**
 * @return {?}
 */
private watchItemClick(): void {
            this.clickWatcher$ = this.panel.instance.menuItemClicked.subscribe(
                  (emitted) => {
                      emitted.callback(this.menuID);
                  }
            );
      }
/**
 * @return {?}
 */
private outsideListener(): void {
            this.render.listen('document', 'click', (event) => {
               if (event.type === 'click' && event.button === 2) {
                  return;
               }
               this._service.closeAllContextMenus();
               this.render.removeClass(this.ref.nativeElement, 'hd-contextmenu-active');
               this.active = false;
            });
      }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[hdContextMenu]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ApplicationRef, },
{type: ViewContainerRef, },
{type: Overlay, },
{type: LayoutService, },
{type: ContextMenuService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'hdContextMenu': [{ type: Output },],
'menuID': [{ type: Input },],
'menuItem': [{ type: Input },],
'_overlayOrigin': [{ type: ViewChild, args: [CdkOverlayOrigin, ] },],
'contextMenuOrigin': [{ type: Input },],
'onContextMenu': [{ type: HostListener, args: ['contextmenu', ['$event'], ] },],
};
}

function ContextMenuDirective_tsickle_Closure_declarations() {
/** @type {?} */
ContextMenuDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContextMenuDirective.ctorParameters;
/** @type {?} */
ContextMenuDirective.propDecorators;
/** @type {?} */
ContextMenuDirective.prototype.hdContextMenu;
/** @type {?} */
ContextMenuDirective.prototype.menuID;
/** @type {?} */
ContextMenuDirective.prototype.menuItem;
/** @type {?} */
ContextMenuDirective.prototype._overlayOrigin;
/** @type {?} */
ContextMenuDirective.prototype.contextMenuOrigin;
/** @type {?} */
ContextMenuDirective.prototype.panel;
/** @type {?} */
ContextMenuDirective.prototype.clickWatcher$;
/** @type {?} */
ContextMenuDirective.prototype.overlayRef;
/** @type {?} */
ContextMenuDirective.prototype.active;
/** @type {?} */
ContextMenuDirective.prototype.ref;
/** @type {?} */
ContextMenuDirective.prototype.render;
/** @type {?} */
ContextMenuDirective.prototype.ar;
/** @type {?} */
ContextMenuDirective.prototype.vc;
/** @type {?} */
ContextMenuDirective.prototype.overlay;
/** @type {?} */
ContextMenuDirective.prototype.layoutService;
/** @type {?} */
ContextMenuDirective.prototype._service;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
